import React, {useMemo} from "react";
import {Cell, Pie, PieChart, ResponsiveContainer, Tooltip} from "recharts";
import {formatNumber, formatPercent, GROUP_PALETTE, OTHER_GROUP_COLOR} from "../Statistics/format.js";
import {bereichLabel} from "./format.js";
import NutzungWidget from "./NutzungWidget.jsx";

/** Bereichsverteilung des Mitarbeiters als Ring - dieselbe Datenform wie
 * der Bereichs-Endpunkt des Überblicks ({bereich, ereignisse, anteil}). */
export default function NutzungProfilBereichsring({bereiche, loading, error}) {
    const rows = Array.isArray(bereiche) ? bereiche : [];
    const sortiert = useMemo(() => [...rows].sort((a, b) => (b.ereignisse || 0) - (a.ereignisse || 0)), [rows]);

    return (
        <NutzungWidget
            title="Bereichsverteilung"
            help="Anteil der Ereignisse je Bereich im gewählten Zeitraum."
            loading={loading}
            error={error}
            empty={!loading && !error && sortiert.length === 0}
            height={280}
        >
            <ResponsiveContainer width="100%" height={280}>
                <PieChart>
                    <Pie data={sortiert} dataKey="ereignisse" nameKey="bereich" innerRadius={60} outerRadius={100} paddingAngle={2}>
                        {sortiert.map((row, index) => (
                            <Cell key={row.bereich} fill={GROUP_PALETTE[index % GROUP_PALETTE.length] || OTHER_GROUP_COLOR} />
                        ))}
                    </Pie>
                    <Tooltip
                        formatter={(value, name, item) => [
                            `${formatNumber(value)} (${formatPercent((item?.payload?.anteil || 0) * 100)})`,
                            bereichLabel(name),
                        ]}
                    />
                </PieChart>
            </ResponsiveContainer>
        </NutzungWidget>
    );
}
